import {
  AbsoluteContainer,
  Cushion,
  Grid,
  GridItem,
  Rectangle,
  Space,
  Typography,
} from '@pitchero/react-ui';
import { find } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import VideoIcon from '@pitchero/react-ui/dist/cjs/components/Icons/Video';
import Card from '../card';
import IconWithTheme from '../icon-with-theme';
import Video from '../video/dynamic';
import { Trans } from '../../lib/i18n';

const MatchVideos = ({ videos }) => {
  if (videos.length === 0) {
    return null;
  }

  const [interactedWithVideos, setInteractedWithVideos] = useState(false);
  const [activeVideoId, setActiveVideoId] = useState(videos[0].id);

  const activeVideo = find(videos, { id: activeVideoId }) || {};
  const { author } = activeVideo;
  const hasOtherVideos = videos.length > 1;

  const durationToTimeString = (duration) => {
    const minutes = Math.floor(duration / 60);
    const seconds = duration - minutes * 60;
    return `${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`;
  };

  return (
    <Space bottom="large">
      <Rectangle fill="white" radius="rounded">
        <Video
          videoOptions={{
            autoplay: interactedWithVideos,
            videoUrl: activeVideo.url,
            controls: true,
            aspectRatio: '16:9',
            poster: activeVideo.thumbnail,
          }}
          key={`video${activeVideo.id}`}
        />
        <Cushion all="large">
          <Space bottom="small">
            <Typography preset="subtitle--large" component="div">
              {activeVideo.title}
            </Typography>
          </Space>
          {author && (
            <Typography preset="button" color="dovegrey">
              <Trans i18nKey="common:by_author" values={{ author: author.name }}>
                {`By ${author.name}`}
              </Trans>
            </Typography>
          )}
        </Cushion>
        {hasOtherVideos && (
          <Rectangle fill="alabaster" radius="roundedBottom">
            <Cushion all="medium">
              <Grid
                columns="1fr 1fr"
                rowGap="medium"
                columnGap="medium"
                responsive={[{ maxWidth: 700, props: { columns: '1fr' } }]}
              >
                {videos.map((video) => (
                  <GridItem
                    key={video.id}
                    onClick={() => {
                      setActiveVideoId(video.id);
                      setInteractedWithVideos(true);
                    }}
                    component="div"
                    style={{
                      cursor: 'pointer',
                      opacity: video.id === activeVideoId ? 0.5 : 1,
                    }}
                  >
                    <Card
                      key={video.id}
                      stacked="never"
                      imageSrc={video.thumbnail}
                      imagePreset="card"
                      category={durationToTimeString(video.duration)}
                      renderAfterImage={() =>
                        video.id !== activeVideoId && (
                          <AbsoluteContainer top="50%" left="50%">
                            <IconWithTheme>
                              <VideoIcon
                                size={48}
                                style={{ marginLeft: -24, marginTop: -24 }}
                                colorOne="primary"
                                colorTwo="primaryContrast"
                              />
                            </IconWithTheme>
                          </AbsoluteContainer>
                        )
                      }
                      title={video.title}
                    />
                  </GridItem>
                ))}
              </Grid>
            </Cushion>
          </Rectangle>
        )}
      </Rectangle>
    </Space>
  );
};

MatchVideos.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      thumbnail: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      author: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  ).isRequired,
};

export default MatchVideos;
